import $ from "jquery";
import bdjs from "@bd-core/bdjs";

export const HomePage = () => {
    const isHomePage = $("#page-home").length > 0;
    if (!isHomePage) return false;

    bdjs.hideLoading();

    const handleCaseClick = function () {
        const $this = $(this);

        if ($this.hasClass("is-chosen") 
            || $this.hasClass("is-waiting") 
            || $this.hasClass("is-ready") 
            || $this.hasClass("is-locked")) return false;

        $this.addClass("is-chosen");
    }

    const handleCaseButtonClick = function () {
        const $this = $(this);
        const $case = $this.closest(".home__case");

        if ($case.hasClass("is-chosen")) {
            $case.removeClass("is-chosen").addClass("is-waiting");
        } else if ($case.hasClass("is-waiting")) {
            $case.removeClass("is-waiting");
        }
    }

    $(".home__case").on("click", handleCaseClick);
    $(".js-case-btn").on("click", handleCaseButtonClick);

    $(document).on("click", function (e) {
        if (!$(e.target).is(".home__case") && !$(e.target).closest(".home__case").length) {
            $(".home__case").removeClass("is-chosen");
        }
    });
};
